export default "__VITE_ASSET__BtU5p$sX__"